import api from './api';
import type {
    StudentApplication,
    ApplicationsListResponse,
    PaymentSubmission
} from '../types';


class ApplicationService {
    /**
     * Get all applications for the current user
     */
    async getMyApplications(statusFilter?: string): Promise<ApplicationsListResponse> {
        const params = statusFilter ? { status_filter: statusFilter } : {};
        const response = await api.get<ApplicationsListResponse>('/admissions/my-applications', { params });
        return response.data;
    }

    /**
     * Get detailed information for a specific application
     */
    async getApplicationById(id: number): Promise<StudentApplication> {
        const response = await api.get<StudentApplication>(`/admissions/my-applications/${id}`);
        return response.data;
    }

    /**
     * Submit payment details for an application
     */
    async submitPayment(id: number, data: PaymentSubmission): Promise<StudentApplication> {
        const response = await api.post<StudentApplication>(`/admissions/my-applications/${id}/submit-payment`, data);
        return response.data;
    }

    /**
     * Cancel an application
     */
    async cancelApplication(id: number): Promise<StudentApplication> {
        const response = await api.post<StudentApplication>(`/admissions/my-applications/${id}/cancel`);
        return response.data;
    }
}

export default new ApplicationService();
